import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    redirect: '/mobile/works'
  },
  {
    path: '/pc',
    redirect: '/pc/works'
  },
  {
    path: '/pc',
    meta: {title: 'pc'},
    component: () => import('@/views/pc'),
    children: [
      {
        path: 'works',
        component: () => import('@/views/pc/works'),
      },
      {
        path: 'news',
        component: () => import('@/views/pc/news'),
      },
      {
        path: 'exhibitions',
        component: () => import('@/views/pc/exhibitions'),
      },
      {
        path: 'texts',
        component: () => import('@/views/pc/texts'),
      },
      {
        path: 'biography',
        component: () => import('@/views/pc/biography'),
      },
    ]
  },
  {
    path: '/mobile',
    redirect: '/mobile/works'
  },
  {
    path: '/mobile',
    meta: {title: 'mobile'},
    component: () => import('@/views/mobile'),
    children: [
      {
        name:'WORKS',
        path: 'works',
        component: () => import('@/views/mobile/works'),
      },
      {
        name:'NEWS',
        path: 'news',
        component: () => import('@/views/mobile/news'),
      },
      {
        name:'EXHIBITIONS',
        path: 'exhibitions',
        component: () => import('@/views/mobile/exhibitions'),
      },
      {
        name:'TEXTS',
        path: 'texts',
        component: () => import('@/views/mobile/texts'),
      },
      {
        name:'BIOGRAPHY',
        path: 'biography',
        component: () => import('@/views/mobile/biography'),
      },
      {
        name:'CONTACT',
        path: 'contact',
        component: () => import('@/views/mobile/contact'),
      },
    ]
  }
]

const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
